import { useEffect, useRef, useState } from "react";

const COUNT_KEY = "raijada_community_popup_count";
const MAX_SHOWS = 3;
const DELAYS = [15000, 55000, 110000];

const isAnyDialogOpen = () => !!document.querySelector('[role="dialog"][data-state="open"]');

export const useCommunityPopup = () => {
  const [open, setOpen] = useState(false);
  const timersRef = useRef([]);

  const openManually = () => setOpen(true);

  useEffect(() => {
    const attemptShow = () => {
      const current = parseInt(sessionStorage.getItem(COUNT_KEY) || "0", 10);
      if (current >= MAX_SHOWS) return;
      if (isAnyDialogOpen()) {
        timersRef.current.push(setTimeout(attemptShow, 3000));
        return;
      }
      sessionStorage.setItem(COUNT_KEY, String(current + 1));
      setOpen(true);
    };

    const count = parseInt(sessionStorage.getItem(COUNT_KEY) || "0", 10);
    if (count >= MAX_SHOWS) return;

    DELAYS.slice(count).forEach((delay) => {
      timersRef.current.push(setTimeout(attemptShow, delay));
    });

    return () => timersRef.current.forEach(clearTimeout);
  }, []);

  return { open, setOpen, openManually };
};
